<template>
  <v-card class="card">
    <v-row justify="space-between">
      <v-col cols="auto"></v-col>
      <v-col cols="auto">
        <h2 class="card-title">{{ $t('riderStatus.name', { name: data.name }) }}</h2>
      </v-col>
      <v-col cols="auto">
        <v-btn @click="clear" text="text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div class="card-content">
      <div class="site-infos">
        <div class="site-info-item">
          <div class="info-header">{{ $t('riderStatus.from', { from: data.from }) }}</div>
        </div>
        <div class="site-info-item">
          <div class="info-header">{{ $t('riderStatus.phoneNumber', { phoneNumber: data.phoneNumber }) }}</div>
        </div>
        <div class="site-info-item">
          <div class="info-header">{{ $t('riderStatus.email', { email: data.email }) }}</div>
        </div>
        <div class="site-info-item space-between">
          <div class="info-header">{{ $t('riderStatus.alert', { alert: data.alert }) }}</div>
          <div class="info-content">
            <v-switch class="site-switch" v-model="data.alert"></v-switch>
          </div>
        </div>
        <div class="site-info-item space-between">
          <div class="info-header">{{ $t('riderStatus.suspended') }}：</div>
          <div class="info-content">
            <v-switch class="site-switch" v-model="data.suspended"></v-switch>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    ...mapActions({
      clear: 'rider/clearSelected'
    })
  }
}
</script>

<style lang="stylus" scoped>
  .card
    padding 30px

  .card-title
    width 100%
    text-align center

  .site-status
    display block
    width fit-content
    margin 0 auto
    padding 6px 30px
    border-radius 16px

  .site-info-item
    display flex
    align-items center
    font-size 20px
    margin 24px 0
    &:not(:last-of-type)
      margin-bottom 24px
    &.space-between
      justify-content space-between
      margin-bottom 0

  .site-switch
    margin-top 0
    padding-top 0
    .v-input__slot
      margin-bottom 0
    &/deep/ .v-messages
      display none
</style>
